export default __webpack_public_path__ + "static/media/image-study-admin-w@2x.0e1a486c.png";